module.exports = __webpack_public_path__ + "img/icon-weixin.1f5178cc.png";